export class MessageModel {
  constructor (data = {}) {
    this.id = data.id || null
    this.sessionId = data.sessionId || null
    this.role = data.role || 'user' // 'user', 'assistant', 'system'
    this.content = data.content || ''
    this.tokenCount = data.tokenCount || null
    this.cost = data.cost || null
    this.createdAt = data.createdAt || null
    this.isStreaming = data.isStreaming || false
    this.isError = data.isError || false
  }

  loadModel (messageData) {
    this.id = messageData.id
    this.sessionId = messageData.sessionId
    this.role = messageData.role
    this.content = messageData.content
    this.tokenCount = messageData.tokenCount
    this.cost = messageData.cost
    this.createdAt = messageData.createdAt
  }

  toSendDto () {
    return {
      content: this.content,
      stream: false
    }
  }

  getDisplayTime () {
    if (!this.createdAt) return ''
    const date = new Date(this.createdAt)
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  getCostDisplay () {
    if (!this.cost) return null
    return `$${this.cost.toFixed(6)}`
  }

  getRoleIcon () {
    const icons = {
      user: 'fas fa-user',
      assistant: 'fas fa-robot',
      system: 'fas fa-info-circle'
    }
    return icons[this.role] || 'fas fa-question-circle'
  }
}
